<template>
    <div 
        v-if="shouldShow"
        class="p-24 text-center flex flex-col items-center justify-center"
    >
        <BaseSvg name="icon-search" class="fill-gray-tier-7 w-10 h-10"/>
        <span class="font-medium text-xl">{{ $t("No results for") }} "{{ searchTerm }}"</span>
        <p class="text-sm type-secondary">
            {{ $t("Pro tip: Searches don't require an exact match. Try typing less, or use a different word or phrase") }}
        </p>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { BaseSvg } from "@/Components";

const props = defineProps({
    searchTerm: {
        type: String,
        default: ''
    },
    searchResultsTerm: {
        type: String,
        default: ''
    },
    hasResults: {
        type: Boolean,
        default: false
    },
    isLoading: {
        type: Boolean,
        default: false
    }
});

const shouldShow = computed(() => {
    return !props.hasResults &&
           props.searchTerm.length > 0 &&
           !props.isLoading &&
           (props.searchTerm === props.searchResultsTerm);
});
</script>